// extracted by mini-css-extract-plugin
export default {"aiTextsError":"R70EoHOSAtiPOt9FbhDk","noBackground":"wkK1Ixr62cOQyTszDhhy","aiTextsErrorMessage":"nSAdVGB_9veLlD6leZT7","aiTextsErrorIcon":"wonfDDP3BqV4zxovSKMV"};